/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{transformProps as e}from"../../render/html/utils/transform.js";const s={type:"spring",stiffness:500,damping:25,restSpeed:10},t={type:"keyframes",duration:.8},r={type:"keyframes",ease:[.25,.1,.35,1],duration:.3},a=(a,{keyframes:n})=>n.length>2?t:e.has(a)?a.startsWith("scale")?{type:"spring",stiffness:550,damping:0===n[1]?2*Math.sqrt(550):30,restSpeed:10}:s:r;export{a as getDefaultTransition};
//# sourceMappingURL=default-transitions.js.map
